import { AHText, Box, Circle, TouchableBox } from "arkh";
import React, { useCallback } from "react";
import { useWeekdays } from "../../../common/useWeekdays";
import { Platform } from "react-native";
import * as Haptics from "expo-haptics";

export const WeekdaySelector = (props: {
  selectedWeekdays: number[];
  onPressWeekday(weekday: number): void;
}) => {
  const weekdays = useWeekdays("narrow");
  const renderWeekday = useCallback(
    (wd: string, index: number) => (
      <TouchableBox
        key={index}
        style={{ alignItems: "center" }}
        hitSlop={{ top: 25, left: 7, right: 7, bottom: 35 }}
        onPressIn={() => {
          if (Platform.OS === "ios") {
            Haptics.impactAsync(Haptics.ImpactFeedbackStyle.Light);
          }
        }}
        onPress={() => {
          props.onPressWeekday(index);
        }}
      >
        <Circle
          size="medium"
          color={
            props.selectedWeekdays.includes(index)
              ? "status-active"
              : "surface-backgroundControl"
          }
        >
          <AHText
            type="subtitle"
            color={
              props.selectedWeekdays.includes(index)
                ? "text-inverted"
                : "text-primary"
            }
          >
            {wd}
          </AHText>
        </Circle>
      </TouchableBox>
    ),
    [props]
  );

  return (
    <Box
      style={{
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
      }}
      spaceHorizontal="xsmall"
    >
      {weekdays.map(renderWeekday)}
    </Box>
  );
};
